module.exports = __webpack_public_path__ + "img/calendar-icon.5231139c.svg";